import { useContext } from 'react'
import ViewContext from '../contexts/view-context'

const useViewContext = () => {
  return useContext(ViewContext)
}

export default useViewContext
